//========================================================================================
/*
  campus,     [obj] 
  title       [str]
  showAddress [bool]
 */
//========================================================================================

import React from 'react';

// Styles & Images
import s from './CampusBlock.style';


const CampusBlock = (props) => {
  const { campus, title, showAddress } = props;

  return (campus || title ?
    <s.CampusBlockWrapper className="campus-block-container">

      <svg width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
          <path d="M3 0h24v24H3z" />
          <path fill="#A2A4B2" fillRule="nonzero"
            d={`M6 21h2v-2H6v2zm3 3h2v-5H9v5zm4 0h2v-5h-2v5zM3 21h2v-2H3v2zm0 3h2v-2H3v2zm3 
            0h2v-2H6v2zm10 0h2v-2h-2v2zm3-3h2v-2h-2v2zm0 3h2v-2h-2v2zm-3-3h2v-2h-2v2zM6 15h2v-2H6v2zm0 
            3h2v-2H6v2zm-3-3h2v-2H3v2zm0 3h2v-2H3v2zm16-3h2v-2h-2v2zm0 3h2v-2h-2v2zm-3-3h2v-2h-2v2zm0 
            3h2v-2h-2v2zm-3-3h2v-2h-2v2zm0 3h2v-2h-2v2zm-4-3h2v-2H9v2zm4-3h2v-2h-2v2zm-4 0h2v-2H9v2zm0 
            6h2v-2H9v2zm9-8V7H6v3H0v14h2V12h6V9h8v3h6v12h2V10h-6zm-7-6h2v2h2V0h-2v2h-2V0H9v6h2V4z`} />
        </g>
      </svg>

      <div className="campus-details">
        <p className="campus-name">{title || campus && campus.name}</p>
        {showAddress && campus && campus.address ? <p className="campus-address">{campus.address}</p> : null}
      </div>
    </s.CampusBlockWrapper>
    : null
  );
};

export default CampusBlock;
